import callApi from "./callApi";

export const getUserNotifications = async (page, pageSize, filterUnread=false) => {
  const url = `notifications?page=${page}&pageSize=${pageSize}&filterUnread=${filterUnread}`;
  const headers = {};
  return callApi(url, headers, "GET");
};

export const markAllRead = async () => {
  const url = `notifications/mark_all_read`;
  const headers = {};
  return callApi(url, headers, "PUT");
};

export const markNotificationRead = async (id) => {
  const url = `notifications/mark_read/${id}`;
  const headers = {};
  return callApi(url, headers, "PUT");
};

export const clearAllNotifications = async () => {
  const url = `notifications/clear_all`;
  const headers = {};
  return callApi(url, headers, "PUT");
};

export const getPreferences = async (projectId) => {
  const url = `notifications/${projectId}/user/preferences`;
  const headers = {};
  return callApi(url, headers, "GET");
};

export const updatePreferences = async (projectId, preferences) => {
  const url = `notifications/${projectId}/user/preferences`;
  const headers = { "Content-Type": "application/json" };
  const body = { preferences };
  return callApi(url, headers, "PUT", body);
};

export const connectSlack = async (userId) => {
  const url = `oauth/slack/url?state=${userId}`;
  const headers = {};
  return callApi(url, headers, "GET");
};

export const slackExchange = async (state, code) => {
  const url = `oauth/slack/callback?state=${state}&code=${code}`;
  return callApi(url, {}, 'GET');
};

export const getSlackChannels = async (projectId) => {
  const url = `notifications/${projectId}/slack/channels`
  const headers = {}
  return callApi(url, headers, 'GET')
}

export const getSlackChannelConfig = async (projectId) => {
  const url = `notifications/${projectId}/slack/channels/config`
  const headers = {}
  return callApi(url, headers, 'GET') 
}

export const updateSlackChannelMappings = async (projectId, mappings) => {
  const url = `notifications/${projectId}/slack/channels/config`
  const headers = { "Content-Type": "application/json" }
  const body = { mappings }
  return callApi(url, headers, 'PUT', body)
}

export const toggleProjectSlack = async (projectId, enabled) => {
  const url = `notifications/${projectId}/slack/details`
  const headers = { "Content-Type": "application/json" }
  const body = { enabled }
  return callApi(url, headers, 'PUT', body)
}

export const getSlackIntegration = async (projectId) => {
  const url = `notifications/${projectId}/slack/details`;
  const headers = {};
  return callApi(url, headers, 'GET');
};

export const getSlackEvents = async (projectId) => {
  const url = `notifications/${projectId}/slack/events`;
  return callApi(url, {}, 'GET');
};
